import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HomepagelocalService } from '../countryhome.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-benefits-section',
  templateUrl: './benefits.component.html',
  imports: [CommonModule, ToHtmlPipe],
})
export class BenefitsSectionComponent implements OnInit {
  @Input() pageData:any;
  constructor(private homePageService: HomepagelocalService) {}

  benefitsData: any;

  ngOnInit(): void {
    const data = this.pageData?.values?.fields;
    if (data) {
      this.benefitsData = data;
    }
  }
  ngOnChanges(): void {
    const data = this.pageData?.values?.fields;
    if (data) {
      this.benefitsData = data;
    }
  }
}
